import { useEffect, useState } from 'react'
import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Button, Spinner } from '@k1p4/ui'
import { api, type AuthEntryResponse } from '../../api/client'
import { withLang } from './portalLinks'
import styles from './Login.module.css'

/**
 * Przekazanie do rejestracji w portalu 33rp (ADR 0001 w `erp/33rp`, pkt 3).
 *
 * Nie ślepe przekierowanie, tylko krótki ekran z widocznym POWODEM i działającym
 * „Wstecz": człowiek, który kliknął „Wypróbuj za darmo" na landingu k1p4, ma
 * wiedzieć, dlaczego ląduje na innej stronie. Portal z `?module=k1p4` pokazuje
 * znak modułu, a po założeniu organizacji odsyła wprost pod adres obszaru.
 *
 * Adres rejestracji przychodzi z serwera (skonfigurowany issuer), nie z literału.
 */
export function RegisterHandoff() {
  const { t, i18n } = useTranslation()
  const [entry, setEntry] = useState<AuthEntryResponse | null>(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    const controller = new AbortController()
    api
      .authEntry(controller.signal)
      .then(setEntry)
      .catch(() => {
        if (!controller.signal.aborted) setFailed(true)
      })
    return () => {
      controller.abort()
    }
  }, [])

  const registrationUrl = entry?.registrationUrl
    ? withLang(entry.registrationUrl, i18n.language)
    : null

  return (
    <>
      <h1 className={styles.heading}>{t('registerHandoff.title')}</h1>
      <p className={styles.subtitle}>{t('registerHandoff.body')}</p>

      {entry === null && !failed ? (
        <p className={styles.center}>
          <Spinner label={t('common.loading')} />
        </p>
      ) : null}

      {registrationUrl ? (
        <a href={registrationUrl}>
          <Button className={styles.ssoButton} size="lg">
            {t('registerHandoff.cta')}
          </Button>
        </a>
      ) : null}

      {failed || (entry !== null && registrationUrl === null) ? (
        <p className={styles.notice} role="status">
          {t('auth.portalUnavailable')}
        </p>
      ) : null}

      <p className={styles.footerPrompt}>
        {t('registerHandoff.haveAccount')}{' '}
        <Link to="/login" className={styles.footerLink}>
          {t('registerHandoff.signIn')}
        </Link>
      </p>
    </>
  )
}
